<marv-drawer #drawerMissionDetails size="big" (onDidDismiss)="this.onDidDismissDrawerMission($event)">
    @if(this.missionItemSelected){
        <app-mission-details 
            [operationId]="this.missionItemSelected.operation.id" 
            [missionId]="this.missionItemSelected.missionId" 
            [activityId]="this.missionItemSelected.activityId" 
            [source]="this.missionItemSelected.source" 
            (onUpdateMission)="this.onUpdateMission($event)"
            (onDeleteMission)="this.onDeleteMission($event)"
            />
    }
</marv-drawer>

<ion-grid class="no_padding" >        
    <ion-row class="ion-align-items-center ion-justify-content-between"> 
        <ion-col size="12" size-md="6" class="title_card">
            {{'MISSONS_WITHIN_5_DAYS' | translate}}
            <marv-circle>{{this.missionsItemsToDisplay.length}}</marv-circle>            
        </ion-col> 
       
        <ion-col size="12" size-md="6" class="no_padding">
            <div class="missions_progress_bar">
                <ion-label>{{'MISSIONS_VALIDATED' | translate}}</ion-label>
                <marv-progress-bar [value]="this.nbMissionsValidated" [max]="this.missionsItemsToDisplay.length" [showPourcent]="false" [showMax]="false" size="small" color="blue"/>
            </div>
            <div class="missions_progress_bar">
                <ion-label>{{'MISSIONS_AFFECTED' | translate}}</ion-label>
                <marv-progress-bar [value]="this.nbMissionsAffected" [max]="this.missionsItemsToDisplay.length" [showPourcent]="false" [showMax]="false" size="small" color="green"/>
            </div>
        </ion-col>        
    </ion-row> 
    
</ion-grid>

<div id="missions_today_list" class="ion-content-scroll-host">
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else {
        @if(this.missionsItemsDisplayed.length > 0){    
            @for(missionItem of this.missionsItemsDisplayed; track $index){
                <app-mission-item [mission]="missionItem" [displayReport]="false" (onSelectMission)="this.onSelectMission($event)"/>
            }
            <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
                <ion-infinite-scroll-content></ion-infinite-scroll-content>
            </ion-infinite-scroll>
        }
        @else{
            <marv-message type="info">{{'MSG_NO_MISSION_WITHIN_5_DAYS' | translate}}</marv-message>
        }
    }
</div>
